import { IUser } from "../../../model/respone/user/IUser";
import { IUserLoadError, IUserLoadStart, IUserLoadSuccess, eUserActionTypeIds } from "../../action-types/user/IUserActionTypes";
import { baseAction } from "../IActionBase";

export const userActions = {
    loadUserStart: (): IUserLoadStart => baseAction(eUserActionTypeIds.LOAD_START, undefined),
    loadUserSuccess: (data: IUser[]): IUserLoadSuccess => baseAction(eUserActionTypeIds.LOAD_SUCCESS, data),
    loadUserError: (message?: string): IUserLoadError => baseAction(eUserActionTypeIds.LOAD_ERROR, message),
}